import React, {useState,useRef,useEffect} from "react";
import Main from "../../components/template/Main";
import { toBase64,replaceType } from "../../util/Imagem";
import { useParams,useHistory } from "react-router-dom";
import file from '../../assets/imgs/File.png';
import { post,get,put } from "../../store/config/register";
import { toast } from "react-toastify";


const headerProps = {
    icon: "file",
    title: "Documento",
    subtitle: "Cadastro"
}

const initialState ={
    tarefa: {
        id: 0,
        idAtividade: 0,
        idTarefa: 0,
        titulo: '',
        descricao: '',
        documento: '',
    }
  }

let type ='';

export default function TarefaDocumento(){
    const {id, idTarefa,idDocumento} = useParams();
    const [tarefaDocumento,setTarefaDocumento] = useState(initialState.tarefa);
    const [anexo,setAnexo]=useState(false);
    const hiddenFileInput = useRef(null);
    const history = useHistory();

    function  updateField( event){
        const tare ={...tarefaDocumento}
        tare[event.target.name] = event.target.value
        setTarefaDocumento(tare);
    }

    useEffect(()=>{
        setTarefaDocumento({...tarefaDocumento, idAtividade: parseInt(id),idTarefa:parseInt(idTarefa)});
        if(idDocumento !== undefined){
            buscaDocumentos(idDocumento);
        }
    },[]);

    async function buscaDocumentos(idDocumento) {
        const docu = await get(`/ArquivoAtividade/v1/Atividade/Tarefa?IdAtividade=${id}&IdTarefa=${idTarefa}&Id=${idDocumento}`);
        if(docu !== undefined) {
            setTarefaDocumento(docu);
            if(docu.documento !== null){
                setAnexo(true);
            }

        }
    }

    async function Salvar(){
        if(Validar()){
            console.log(tarefaDocumento)
            if(idDocumento === undefined){
                const res =  await post('/ArquivoAtividade/v1',tarefaDocumento);
            }else{
                const res =  await put(`/ArquivoAtividade/v1/${idDocumento}`,tarefaDocumento); 
            }
            
            toast.success('arquivo anexado com sucesso.')
            history.goBack();
        }
    }

    function Validar(){
        if(tarefaDocumento.titulo === ''){
            toast.warning('Escreva um título para o documento em anexo');
            return false;
        }

        if(tarefaDocumento.descricao === ''){
            toast.warning('Escreva uma descrição para o documento em anexo');
            return false;
        }

        if(tarefaDocumento.documento === ''){
            toast.warning('Anexe um arquivo para salvar');
            return false;
        }

        return true;
    }



     async function handleFile(e){
                if(e.target.files[0]){
                  const image = e.target.files[0];
                  
                  type='';
                  if(image.type === 'application/pdf'){
        
                type =image.type;
                let base64 = await toBase64(image);  
                let resp =  replaceType(base64);
               // agendaSelecionada.tipo = image.type;
                    setTarefaDocumento({...tarefaDocumento,documento:resp});
                    setAnexo(true);
                  }else{
                    alert('Envie um arquivo do tipo PDF');
                    return null;
                  }
            
                }
            
              }

              function anexarDocumento(agenda){
                hiddenFileInput.current.click(agenda);
              }

    function renderForm(){
        return(
            <div className="form">
                <div className="email">
                    <div className="form-group">
                    <label>Título:</label>
                    <input type="text" name="titulo" 
                    placeholder="Titulo"
                        className="form-control" value={tarefaDocumento.titulo} 
                        onChange={e => updateField(e)} />
                    </div>
                </div>
                <div className="email">
                    <div className="form-group">
                    <label>Descrição:</label>
                    <input type="text" name="descricao" placeholder="Descrição"
                        className="form-control" value={tarefaDocumento.descricao} 
                        onChange={e => updateField(e)} />
                    </div>
                </div>
                <label>Documento:</label>
                <div className="img_foto">
                <input type="file"  onChange={e => handleFile(e)} ref={hiddenFileInput} style={{display: 'none'}}/>  
                    <button className="btn btn-dark ml-2" onClick={()=> anexarDocumento()}>Anexar</button>
                    {anexo && (
                        <img src={file} width={45} height={45} />
                    )}
                    
                </div>
            
                    <div id="botao">
                    <button  className="btn btn-primary ml-2" onClick={ async e => await Salvar(tarefaDocumento)}>
                        Salvar
                    </button>
                    <button className="btn btn-secondary ml-2" onClick={e => history.goBack()}>
                        Cancelar
                    </button>
                </div>       
            </div>
        );
    }
    return (
        <Main {...headerProps}>
            {renderForm()}
        </Main>
    );
}